import React from 'react';
import { Link } from 'react-router-dom';

import styled from 'styled-components';
import media from 'styled-media-query';

import ButtonOutline from 'components/layout/button-outline/ButtonOutline';
import { Text } from 'styles/Layout';

const CategoryHelpBlockWrapper = styled.div`
    display: grid;
    grid-gap: 1rem;
    margin-bottom: 2rem;

    ${media.greaterThan('medium')`
        ${({desktopHidden}) => desktopHidden && 'display: none;'}
	`}
`;

const CategoryHelpBlock = ({ text, desktopHidden }) => (
    <CategoryHelpBlockWrapper desktopHidden={desktopHidden}>
        <Text>{text}</Text>
        <Link to="/enviar-duvida">
            <ButtonOutline label="Enviar dúvida" width="100%" />
        </Link>
    </CategoryHelpBlockWrapper>
);

export default CategoryHelpBlock;